<template>
  <Select
    v-model="brandNames"
    @onSearch="onSearch"
    @onSelect="onSelect"
    @filter="onFilter"
    @onClear="onClear"
    :options="getBrands"
    title="Marka"
    placeholder="Marka Seçimi"
    v-readonly
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>
<script>
import brandService from '@/services/brand';
import Select from '@/pages/AddFromCatalog/Components/Select';

let brandNameRequestTimeout;
export default {
  name: 'BrandSelect',
  components: { Select },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      response: [],
      brands: [],
      brandNames: [],
    };
  },
  computed: {
    getBrands () {
      return this.brands;
    },
  },
  methods: {
    async getData (search) {
      const response = await brandService.getBrandByName({
        name: search,
        page: 0,
      });
      if (response.length > 0) {
        this.response = response;
      }
    },
    setBrands () {
      const brands = [];
      this.response.map(option => {
        if (this.brandNames.find(brand => brand === option.name)) {
          brands.push({
            label: option.name,
            id: option.id,
            isChecked: true,
          });
        } else {
          brands.push({
            label: option.name,
            id: option.id,
            isChecked: false,
          });
        }
      });
      this.brands = brands;
    },
    onFilter (brands, brandNames) {
      this.brandNames = brandNames;
      this.$emit('brandFilter', brands, brandNames);
    },
    async onSearch (search) {
      clearTimeout(brandNameRequestTimeout);
      brandNameRequestTimeout = setTimeout(async () => {
        await this.getData(search);
        this.setBrands();
      }, 500);
    },
    onSelect (option) {
      this.$emit('input', option);
    },
    onClear () {
      this.$emit('input', {});
    },
  },
  async created () {
    await this.getData('ab');
    this.brandNames = this.value;
    this.setBrands();
  },
};
</script>
